import TransitApi from './base'

export default {
  // Listar menús con paginación
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/menu/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Obtener árbol de menús (jerárquico)
  async getTree() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/menu/tree')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Obtener total de menús
  async getTotal() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/menu/get-total')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Obtener detalles de un menú
  async getById(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/menu/details/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Crear nuevo menú
  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/menu/details/${params.id}` : '/menu/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Eliminar menú
  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/menu/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
